<template>
    <div class="loading-app flex flex-col gap-6">
        <BaseSkeleton width="100%" height="90vh" class="mx-auto"></BaseSkeleton>
    </div>
</template>
